import { cva } from 'class-variance-authority';

export const container = cva('p-size-x6 flex flex-col gap-size-x6 bg-th-color-neutral-0 rounded-border-radius-large');
export const title = cva('font-bold text-xl');
